<div class="avatar">
  @if (Type === 'text') {
    <h4 class="h4-bold m-0 p-0 d-flex">{{ short_name }}</h4>
  }
  @if (Type === 'image') {
    <img
      class="rounded-circle"
      height="32"
      width="32"
      alt="{{ short_name }}'s avatar"
      ngSrc="{{ userImg }}" />
  }
</div>
